import { c as _c } from "react-compiler-runtime";
import { LinkProps } from "next/link";
import { Link as ViewTransitionLink } from "next-view-transitions";
import React from "react";
type AnchorProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "children" | "className" | "href">;
export type Props = LinkProps & AnchorProps & {
  children: React.ReactNode;
  className?: string;
};
export default function Link(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ViewTransitionLink {...props}>{props.children}</ViewTransitionLink>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}